import * as React from 'react';
import Lottie from 'react-lottie';
import * as animationData from '../../lotties/loading.json';
import { css } from 'aphrodite/no-important';
export const LoadingIcon = (props) => {
    const options = {
        loop: true,
        animationData: animationData,
    };
    return (React.createElement("div", { className: css(props.classObject) },
        React.createElement(Lottie, { options: options })));
};
